// A load failure the person can act on (design audit 2026-10-04): the
// message in the usual error box, with a "Try again" button beside it when
// the page can simply ask again. Before this, several pages showed plain
// red text and left the only way forward as reloading the browser.
export function LoadError({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: (() => void) | undefined;
}) {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-red-300 bg-red-50 p-4"
    >
      <p>{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="min-h-11 rounded-lg border border-line-strong bg-white px-4 text-sm font-semibold text-ink hover:bg-paper-2"
        >
          Try again
        </button>
      )}
    </div>
  );
}
